/** Иконки одним набором: обводка, сетка 24, толщина 1.9 — как в макетах. */

type P = { size?: number; color?: string; strokeWidth?: number }

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none' as const,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
})

export const IconClock = ({ size = 23, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
)

export const IconList = ({ size = 23, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M4 6h16M4 12h16M4 18h10" />
  </svg>
)

export const IconClients = ({ size = 23, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M3 21V8l7-4 7 4v13" />
    <path d="M10 21v-5h4v5" />
    <path d="M17 12h4v9" />
  </svg>
)

export const IconMoney = ({ size = 23, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <rect x="2" y="6" width="20" height="13" rx="2.5" />
    <path d="M2 11h20" />
  </svg>
)

export const IconPlay = ({ size = 19, color = '#fff' }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M8 5v14l11-7z" />
  </svg>
)

export const IconPause = ({ size = 17, color = 'currentColor', strokeWidth = 2.2 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M9 5v14M15 5v14" />
  </svg>
)

export const IconStop = ({ size = 16, color = '#fff' }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <rect x="6" y="6" width="12" height="12" rx="2" />
  </svg>
)

export const IconPlus = ({ size = 26, color = '#fff', strokeWidth = 2.6 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M12 5v14M5 12h14" />
  </svg>
)

export const IconBack = ({ size = 24, color = 'currentColor', strokeWidth = 2.2 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="m15 18-6-6 6-6" />
  </svg>
)

export const IconChevron = ({ size = 20, color = 'currentColor', strokeWidth = 2 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="m9 18 6-6-6-6" />
  </svg>
)

export const IconLock = ({ size = 17, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <rect x="3" y="11" width="18" height="10" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
)

export const IconPhone = ({ size = 17, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h2.2a1 1 0 0 1 1 .8l.8 3a1 1 0 0 1-.5 1.1l-1.5.8a12 12 0 0 0 5.8 5.8l.8-1.5a1 1 0 0 1 1.1-.5l3 .8a1 1 0 0 1 .8 1v2.2a1.5 1.5 0 0 1-1.5 1.5A15 15 0 0 1 4 5.5Z" />
  </svg>
)

export const IconCopy = ({ size = 17, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <rect x="9" y="9" width="12" height="12" rx="2" />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
  </svg>
)

export const IconEye = ({ size = 18, color = 'currentColor', strokeWidth = 1.8 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
)

export const IconCloudOff = ({ size = 16, color = 'currentColor', strokeWidth = 1.9 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="M17.5 19a4.5 4.5 0 0 0 1.9-8.6" />
    <path d="M6.3 6.3A6 6 0 0 0 6.2 10.3 3.85 3.85 0 0 0 7 19h8" />
    <path d="m3 3 18 18" />
  </svg>
)

export const IconCheck = ({ size = 18, color = 'currentColor', strokeWidth = 2.2 }: P) => (
  <svg {...base(size)} stroke={color} strokeWidth={strokeWidth}>
    <path d="m5 13 4 4L19 7" />
  </svg>
)
